var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"second-step"},[_c('FacilityDocuForm',{ref:"form",attrs:{"hide-button":""},on:{"dialogClosed":() => { _vm.$emit('dialogClosed') }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }